import React, {memo} from "react";
import AmountTd from "../../../../Table/Common/AmountTd";

function AmountSummary({currencySymbol, text, isBold = false}) {
    const content = () => {
        // isBold is either a boolean or an index, if index = 0 we still want it to be bold
        if (isBold || isBold === 0) {
            return (
                <strong className="full-width">
                    <AmountTd currency_code={currencySymbol} amount={text} className="full-width" />
                </strong>
            );
        }
        return (
            <AmountTd currency_code={currencySymbol} amount={text} className="full-width" />
        );
    };

    return (
        content()
    );
}

export default memo(AmountSummary);
